import { gql } from '@apollo/client';

import { support_contact_clicked } from '@/analytics';

import { useContactSupportLink_TenantFragment } from './graphql-types/useContactSupportLink_TenantFragment';
import { useContactSupportLink_UserFragment } from './graphql-types/useContactSupportLink_UserFragment';

export const useContactSupportLink = (
  user?: useContactSupportLink_UserFragment | null,
  tenant?: useContactSupportLink_TenantFragment | null
): {
  contactSupportLink: string;
  contactSupportText: string;
  handleContactSupportClick: () => void;
} => {
  const contactSupportLink = tenant?.customContactSupportLinkV2
    ? {
        contactSupportLink: tenant.customContactSupportLinkV2.url,
        contactSupportText: tenant.customContactSupportLinkV2.text,
      }
    : {
        contactSupportLink: `mailto:support@tradewing.com`,
        contactSupportText: 'Contact Support',
      };

  return {
    ...contactSupportLink,
    handleContactSupportClick: () => {
      support_contact_clicked({
        entity_id: user?._id,
        entity_type: 'user',
        support_channel: contactSupportLink.contactSupportLink.startsWith(
          'mailto:'
        )
          ? 'email'
          : 'external_link',
        support_link_url: contactSupportLink.contactSupportLink,
        support_link_text: contactSupportLink.contactSupportText,
        tenant_id: tenant?._id,
        association_code: tenant?.associationCode,
      });
    },
  };
};

useContactSupportLink.userFragment = gql`
  fragment useContactSupportLink_UserFragment on User {
    _id
    firstName
    lastName
    email
  }
`;

useContactSupportLink.tenantFragment = gql`
  fragment useContactSupportLink_TenantFragment on Tenant {
    _id
    associationCode
    customContactSupportLinkV2 {
      text
      url
    }
  }
`;
